// frontend/src/constants/documentTypes.js
//
// Fuente única de verdad para los tipos de documento, orígenes y categorías.
// Antes estaban duplicados (y desincronizados) en Settings.vue, UploadModal.vue,
// ConsultModal.vue y FileTable.vue, lo que provocaba que campos categorizados
// como "Albarán" (con tilde) nunca coincidieran con tipo_doc="Albaran".

// Tipos de documento. El `value` se guarda en BD (sin tildes, simple) y se usa
// para comparar con `field.categoria`. El `text` es solo presentación.
export const DOCUMENT_TYPES = [
  { value: 'Factura', text: 'Factura' },
  { value: 'Albaran', text: 'Albarán' },
  { value: 'Nomina', text: 'Nómina' },
  { value: 'DNI', text: 'DNI' },
  { value: 'Contrato', text: 'Contrato' },
  { value: 'Otro', text: 'Otro' },
];

// Categorías mostradas en /settings. Incluye "Todos" como pseudo-categoría
// (representa campos globales, sin `categoria` asignada en BD).
export const FIELD_CATEGORIES = [
  'Todos',
  ...DOCUMENT_TYPES.map(t => t.value),
];

// Mapa value → text para mostrar el nombre legible en cualquier sitio.
export const DOCUMENT_TYPE_LABELS = Object.fromEntries(
  DOCUMENT_TYPES.map(t => [t.value, t.text])
);

// Orígenes de los documentos. Idem: value sin tildes, text con tildes.
export const DOCUMENT_ORIGINS = [
  { value: 'Correo electronico', text: 'Correo electrónico' },
  { value: 'WhatsApp', text: 'WhatsApp' },
  { value: 'Pagina web', text: 'Página web' },
  { value: 'Escaneo', text: 'Escaneo (Físico)' },
  { value: 'Burofax', text: 'Burofax' },
  { value: 'Certificado', text: 'Certificado' },
  { value: 'Otro', text: 'Otro' },
];

// Tipos de datos para campos personalizados (FieldDefinition.tipo).
export const FIELD_TYPE_LABELS = {
  text: 'Texto',
  date: 'Fecha',
  number: 'Número',
};
